'use strict';
var portalFiltersModule=angular.module('portal.filters', ['dev-stack-frontend.filters']);